export const UNDEFINED_VALUE = 'UndefinedValue';
export const CUSTOMER_ANONYMOUS = 'Anonymous';
export const COMPANY_UNKNOWN = 'Unknown';

export const ADD_TAG_LABEL = 'Add tag';
export const NOT_TAGGED_LABEL = 'Not tagged';

export const UNASSIGNED_LABEL = 'Unassigned';
export const NOT_ASSIGNED_LABEL = 'Not assigned';

export const UNCATEGORIZED_LABEL = 'Uncategorized';

export const DIVIDER_STRING = '/**/';
